import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CropMaster from "../components/CropMasterList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Crop Master" />

        {/* UsersListLayer */}
        <CropMaster />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
